import React from 'react';
import { Wrapper } from './styles';

const ListContainer = ({ offset, children }) => (
  <Wrapper offset={offset ? 1 : null}>{children}</Wrapper>
);

export default ListContainer;
